export default {
  apiBaseURL: 'https://api.revit.allbin.se',
};
